<template>
  <v-card>
    <v-card-title class="d-flex align-center">
      <h1 class="text-2xl font-weight-semibold">
        {{ title }}
      </h1>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="goToNewCustomer"
      >
        {{ $t("new") }}
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :footer-props="footer"
      :items="customers"
      :items-per-page="10"
      :no-data-text="$t('noDataText')"
      item-key="id"
      class="table-rounded"
      multi-sort
    >
      <template #[`item.user.firstAccess`]="{item}">
        {{ item.user.firstAccess | dateFilter }}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              {{ icons.mdiAlarm }}
            </v-icon>
          </template>
          <span>Horário: {{ item.user.firstAccess | timeFilter }}</span>
        </v-tooltip>
      </template>
      <template #[`item.user.lastAccess`]="{item}">
        {{ item.user.lastAccess | dateFilter }}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              {{ icons.mdiAlarm }}
            </v-icon>
          </template>
          <span>Horário: {{ item.user.firstAccess | timeFilter }}</span>
        </v-tooltip>
      </template>
      <template #[`item.occupation`]="{item}">
        {{ item.occupation | ocupationFilter }}
      </template>
      <template #[`item.action`]="{item}">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="secondary"
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="editCustomer(item)"
            >
              <v-icon size="24">
                {{ icons.mdiPencilOutline }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("tooltip.edit") }}</span>
        </v-tooltip>
        <confirmation-modal @on-confirming="deleteCustomer(item)">
          <template v-slot:default="{ dialogOn }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="error"
                  v-bind="attrs"
                  v-on="{ ...on, ...dialogOn }"
                >
                  <v-icon size="24">
                    {{ icons.mdiDeleteOutline }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("tooltip.delete") }}</span>
            </v-tooltip>
          </template>
        </confirmation-modal>
      </template>
      <template v-slot:[`footer.page-text`]="items">
        {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mdiAlarm, mdiPencilOutline, mdiDeleteOutline } from '@mdi/js';
import ConfirmationModal from '@/components/ConfirmationModal.vue';
// import laravelApi from '../../apis/api_laravel';

export default {
  components: {
    ConfirmationModal,
  },
  filters: {
    dateFilter(date) {
      if (!date) {
        return '';
      }

      return new Date(date).toLocaleDateString();
    },
    timeFilter(date) {
      if (!date) {
        return '';
      }

      return new Date(date).toLocaleString().substring(11);
    },
    ocupationFilter(occupation) {
      if (occupation === '') {
        return 'N/A';
      }

      return occupation.replace(' (não sou médico)', '');
    },
  },
  data() {
    return {
      title: 'Usuários',
      customers: [],
      headers: [
        { text: 'Nome', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Primeiro acesso', value: 'user.firstAccess' },
        { text: 'Último acesso', value: 'user.lastAccess' },
        { text: 'Ocupação', value: 'occupation' },
        {
          text: 'Ações',
          align: 'center',
          value: 'action',
          sortable: false,
        },
      ],
      footer: {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageAll: 'Todos',
      },
      icons: {
        mdiPencilOutline,
        mdiDeleteOutline,
        mdiAlarm,
      },
    };
  },
  async mounted() {
    this.refreshUser();
  },
  methods: {
    goToNewCustomer() {
      this.$router.push('/customers/new');
    },
    async refreshUser() {
      try {
        const users = await this.$api.customer.getCustomers();
        users.forEach((element) => {
          if (element.user !== null) this.customers.push(element);
        });
        // ApiLAravelget('/users').then((response) => {
        //   response.data.forEach((element) => {
        //
        //   });
        // });

        // this.customers = response.data;
      } catch (error) {
        this.$store.dispatch('NOTIFICATION_ERROR', error.message);
      }
    },
    editCustomer(customer) {
      this.$router.push(`/customers/edit/${customer.id}`);
    },
    async deleteCustomer(customer) {
      try {
        await this.$api.customer.deleteCustomer(customer.id);
        // laravelApi.delete(`/users/${customer.id}`).then(() => {
        //   this.refreshUser();
        // });
      } catch (error) {
        this.$store.dispatch('NOTIFICATION_ERROR', error.message);
      }
    },
  },
};
</script>
